module.exports = __webpack_public_path__ + "img/mile3-m@1.ef611de4.webp";